module.exports = __webpack_public_path__ + "static/img/product9.87abded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product9.png
// module id = 8fOA
// module chunks = 1